import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { DeviceConfigService } from "@obg/ngx.global";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { map, switchMap, take } from "rxjs/operators";

import { CORE_ROUTE } from "../../../route";
import { CoreState } from "../../../state";
import { DepositLimitConfigService } from "../deposit-limit.config";

import { DepositLimitRequiredService } from "./deposit-limit-required.service";

@Injectable({
	providedIn: "root",
})
export class DepositLimitRequiredGuard implements CanActivate {
	constructor(
		private depositLimitConfig: DepositLimitConfigService,
		private depositLimitRequiredService: DepositLimitRequiredService,
		private deviceConfigService: DeviceConfigService,
		private store: Store<CoreState>
	) {}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (!this.depositLimitConfig.getIsDepositLimitRequired()) {
			return of(true);
		}

		return this.depositLimitRequiredService
			.shouldOpenDepositLimit$()
			.pipe(
				switchMap((shouldRedirect) =>
					!shouldRedirect
						? of(true)
						: this.store.select(RouteSelector.getCurrent).pipe(
								map((currentRoute) => {
									let routeName = CORE_ROUTE.responsibleGaming.depositLimit;

									if (this.deviceConfigService.isDesktop()) {
										if (!currentRoute) {
											routeName = CORE_ROUTE.home;
										} else {
											routeName = this.depositLimitConfig.isSgaDepositLimitDialogEnabled()
												? CORE_ROUTE.responsibleGaming.depositLimitDialog
												: CORE_ROUTE.responsibleGaming.depositLimit;
										}
									}

									return routeName;
								}),
								take(1)
							)
				)
			)
			.pipe(
				map((guardResult) => {
					if (guardResult === false || guardResult === true) {
						return guardResult;
					}

					this.store.dispatch(
						RouteAction.navigate(guardResult, undefined, { queryParams: { returnUrl: state.url } })
					);
					return false;
				})
			);
	}
}
